module.exports = __webpack_public_path__ + "src/images/products/trendsetter/116_Jasper Emroidered Jeans.png";